<!--
 * @Author       : 萝卜兄台
 * @Date         : 2023-03-01 13:34:23
 * @LastEditors  : 萝卜兄台\thund leili995997651@qq.com
 * @LastEditTime : 2024-03-29 17:30:54
 * @FilePath     : \gray-fabric-defect-management-frontend\src\layout\components\menu\index.vue
 * @Description  : 这是导航栏
-->
<template>
  <a-menu theme="dark" mode="inline" v-model:openKeys="openKeys" v-model:selectedKeys="selectedKeys">
    <template v-for="item in menuData" :key="item.path">
      <router-link v-if="!item.children" :to="item.path">
        <a-menu-item :key="item.path">
          <template #icon>
            <component :is="item.meta?.icon ?? 'frown-outlined'" />
          </template>
          <span>{{ $t(item.name) }}</span>
        </a-menu-item>
      </router-link>

      <a-sub-menu v-if="item.children" :key="item.path">
        <template #icon>
          <component :is="item.meta?.icon ?? 'frown-outlined'" />
        </template>

        <template #title>{{ $t(item.name) }}</template>

        <router-link v-for="groupRouter in item.children" :key="groupRouter.path" :to="groupRouter.path">
          <a-menu-item :key="groupRouter.path">{{ $t(groupRouter.name) }}</a-menu-item>
        </router-link>
      </a-sub-menu>
    </template>
  </a-menu>
</template>

<script lang="ts" setup>
import { onBeforeMount, ref, createVNode, watchEffect, toRef } from 'vue'
import {
  UserOutlined,
  VideoCameraOutlined,
  UploadOutlined,
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  PieChartOutlined,
} from '@ant-design/icons-vue'
import Icon from '@ant-design/icons-vue'
import { useRouter, useRoute } from 'vue-router'
import inter from '../../../utils/shared'

import { useI18n } from 'vue-i18n'
const { locale, t } = useI18n()

// import Menu from './index'

const router = useRouter()
const route = useRoute()
const selectedKeys = ref<any>([])
const openKeys = ref<any>([])

const menuData: any = ref([])

onBeforeMount(async () => {
  try {
    let data: any = JSON.parse(localStorage.getItem('user') || '{}')

    let routerMenu:any = await inter.dealRouter(router, { user: data })

    // menuData.value = routerMenu
    menuData.value = router.options.routes[2].children
    menuData.value.filter((e: any) => {
      if (!e.children) {
        return e
      }
      e.children = e.children.filter((c: any) => {
        if (c.name !== "router.cleanData") {
          return c
        }
        if (data.menus.indexOf("/manage/account/clean-data") != -1) {
          return c
        }
      })
      return e
    })
    selectedKeys.value = [route.fullPath]
    let sub = routerMenu.find(
      (e: any) => route.fullPath.indexOf(e.path) > -1
    )?.path
    openKeys.value = [sub]
  } catch (error) {
    console.log('。。。')
  }
})

watchEffect(() => {
  // console.log(openKeys)
  // console.log(selectedKeys)
  // console.log(route.fullPath)
  // console.count()
  let pathUrl
  if (route.fullPath.split('?').length > 1) {
    pathUrl = route.fullPath.split('?')[0]
  } else {
    pathUrl = route.fullPath
  }

  if (selectedKeys.value[0] !== pathUrl) {
    selectedKeys.value = [pathUrl]
  }
  return {
    ...toRef(selectedKeys.value, 1),
  }
})
</script>

<style></style>
